import React, { FC, ReactElement, useEffect, useRef } from 'react';

import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';
import Title from 'common/Title';

import { IPropsOtcDisclaimerContent } from './models';

const OtcDisclaimerContent: FC<IPropsOtcDisclaimerContent> = ({
  title,
  text,
  isFocused,
}): ReactElement | null => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isFocused) contentRef.current?.focus();
  }, []);

  if (!text) {
    return null;
  }

  return (
    <div
      data-test="OtcDisclaimerContent"
      className="otc-disclaimer__info-wrapper"
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      ref={contentRef}
    >
      {title ? (
        <Title dataTestAttr="OtcDisclaimerTitle" className="otc-disclaimer__title">
          {title}
        </Title>
      ) : null}
      <div className="otc-disclaimer__text">
        <DangerouslySetInnerHtml html={text} />
      </div>
    </div>
  );
};

export default OtcDisclaimerContent;
